export enum BlockType {
  CORE_PARAGRAPH = 'core/paragraph',
  CORE_BUTTON = 'core/button',
  CORE_NEXT_PAGE = 'core/nextpage',
  CORE_TABLE = 'core/table',
  CORE_BUTTONS = 'core/buttons',
  CORE_MORE = 'core/more',
  CORE_VERSE = 'core/verse',
  CORE_PREFORMATTED = 'core/preformatted',
  CORE_HEADING = 'core/heading',
  CORE_GROUP = 'core/group',
  CORE_MEDIA_TEXT = 'core/media-text',
  CORE_QUOTE = 'core/quote',
  CORE_LIST = 'core/list',
  CORE_FILE = 'core/file',
  CORE_IMAGE = 'core/image',
  CORE_EMBED_YOUTUBE = 'core-embed/youtube'
}
